import './../action/Router.action';
import * as types from '../type/Router.type';

const defaultData = {
	headerActive: [],
	istop: false,
	schoolPath: '',
	isvedio: false
};

const Router = (state = defaultData, action) => {
	let copyState = { ...state };
	switch (action.type) {
		case 'a':
			copyState.headerActive = action.res;
			return copyState;
		case types.IS_TOP_PAGE:
			copyState.istop = action.res;
			return copyState;
		case types.IS_VEDIO_PAGE:
			copyState.isvedio = action.res;
			return copyState;
		case types.GET_SCHOOL_PATH:
			copyState.schoolPath = action.res;
			return copyState;
		default:
			return copyState;
	}
};
export default Router;



// WEBPACK FOOTER //
// ./src/redux/reducer/Router.reducer.js